var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productNotification)?_c('p',{staticClass:"t-paragraph-large t-paragraph-large--error u-text-align-center"},[_vm._v("\n  "+_vm._s(_vm.productNotification)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }